import { render, staticRenderFns } from "./EditBeneficiaryComponent.vue?vue&type=template&id=457bd36b&scoped=true&"
import script from "./EditBeneficiaryComponent.vue?vue&type=script&lang=js&"
export * from "./EditBeneficiaryComponent.vue?vue&type=script&lang=js&"
import style0 from "vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./EditBeneficiaryComponent.vue?vue&type=style&index=1&id=457bd36b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457bd36b",
  null
  
)

export default component.exports